import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import PaymentInformationBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/PaymentInformation'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  canCustomizeSettings: boolean
  isAutomaticExpensable?: boolean
}

const PaymentInformation = (props: Props) => {
  const { customizationFields } = props

  const paymentField = customizationFields.find((field) => field.identifier === 'payment')
  const paymentMethodField = customizationFields.find(
    (field) => field.identifier === 'payment_method'
  )
  const reimbursableAmountField = customizationFields.find(
    (field) => field.identifier === 'reimbursable_amount'
  )
  const reimbursableCurrencyField = customizationFields.find(
    (field) => field.identifier === 'reimbursable_currency'
  )

  if (
    !paymentField?.enabled &&
    !paymentMethodField?.enabled &&
    !reimbursableCurrencyField?.enabled &&
    !reimbursableAmountField?.enabled
  )
    return null

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.payment_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.payment_information_subtitle')}
    >
      <PaymentInformationBlock {...props} />
    </FormBlock>
  )
}

export default PaymentInformation
